import { observable } from "mobx"
import moment from "moment"

import { CompanyForNewGradJobDetail as CompanyForNewGradJobDetail__new } from "~/api/new-grad-jobs/_types"

import { createCompanyMemberArgs, CompanyMember } from "./CompanyMember"

export const CompanyStatus = {
  public: "PUBLIC",
  private: "PRIVATE",
}

type CompanyStatusType = keyof typeof CompanyStatus

export interface CreateCompanyArgs {
  id: number
  name: string
  display: string
  site_url: string
  main_img_url: string
  mission?: string
  company_overview: string
  culture?: string
  recommended_points: string
  prefecture: string
  address1: string
  address2: string
  address3: string
  capital: string
  established_on: string | null
  employee_number_range?: { id: number; range: string }
  status?: CompanyStatusType
  url: string
  company_images?: {
    company_id: number
    img_url: string
  }[]
  company_members: createCompanyMemberArgs[]
}

export class Company {
  @observable id: number
  @observable name: string
  @observable siteUrl: string
  @observable mission?: string
  @observable overview: string
  @observable culture?: string
  @observable recommendedPoints: string | null
  @observable logoImgUrl: string
  @observable prefecture?: string
  @observable address1: string
  @observable address2: string
  @observable address3: string
  @observable capital: string
  @observable establishedOn: string | null
  @observable employeeNumberRanges: string
  @observable status?: CompanyStatusType
  @observable url: string
  @observable companyImages?: string[]
  @observable companyMembers?: CompanyMember[]

  constructor(args: CreateCompanyArgs) {
    this.id = args.id
    this.name = args.name || args.display
    this.siteUrl = args.site_url
    this.mission = args.mission
    this.overview = args.company_overview
    this.culture = args.culture
    this.recommendedPoints = args.recommended_points
    this.logoImgUrl = args.main_img_url
    this.prefecture = args.prefecture
    this.address1 = args.address1
    this.address2 = args.address2
    this.address3 = args.address3 || ""
    this.capital = args.capital
    this.establishedOn = args.established_on && moment(args.established_on).format("YYYY年MM月")
    this.employeeNumberRanges = (args.employee_number_range && args.employee_number_range.range) || ""
    this.status = args.status
    this.url = args.url || ""
    this.companyImages = args.company_images && args.company_images.map((images) => images.img_url)
    this.companyMembers = args.company_members && args.company_members.map((member) => new CompanyMember(member))
  }
}

/** @deprecated {@link CompanyForNewGradJobDetail__new} ←これを使う*/
export interface CompanyForNewGradJobDetail {
  id: number
  name: string
  mission: string
  company_overview: string
  culture: string
  established_on: string
  prefecture: string
  address1: string
  address2: string
  address3: string
  main_img_url: string
  employee_number_range: string
}
